import { Injectable } from "@angular/core";
import { BalancePipe } from "@karma-games/angular-devkit/src/lib/modules/pipes";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { from, Observable, switchMap } from "rxjs";
import { GetConfigUseCase } from "../../core/config/get-config.use-case";
import { IBetPanelData } from "src/app/bet-panel/interfaces";

@Injectable({
    providedIn: "root"
})
export class GetBetPanelDataUseCase implements IUseCase<void, Observable<IBetPanelData>> {
    constructor(private balancePipe: BalancePipe,
                private getConfigUseCase: GetConfigUseCase) {
    }

    execute(): Observable<IBetPanelData> {
        return from(this.getConfigUseCase.execute())
            .pipe(switchMap(config => new Observable<IBetPanelData>(subscriber => {
                console.warn(config);
                const predefinedBetOptions = config?.bet.predefinedAmounts ?? [];
                const defaultStepperConfig = {
                    initialValue: 1,
                    step: 0.1,
                    maxValue: 2,
                    minValue: 0.1
                };
                const multiplierPanelStepperDefaultConfig = {
                    initialValue: 1.10,
                    step: 0.01,
                    maxValue: 100000,
                    minValue: 1.01
                };
                const data: IBetPanelData = {
                    predefinedBetOptions: predefinedBetOptions.map(opt => {
                        return {
                            text: { key: `${this.balancePipe.transform(opt)}` },
                            value: opt
                        };
                    }),
                    betStepperConfig: {
                        initialValue: config?.bet.stepper ? config.bet.stepper.initialValue : defaultStepperConfig.initialValue,
                        minValue: config?.minBet ? config.minBet : defaultStepperConfig.minValue,
                        maxValue: config?.maxBet ? config.maxBet : defaultStepperConfig.maxValue,
                    },
                    multiplierStepperConfig: config?.autoCashOutMultiplier?.stepper ?? multiplierPanelStepperDefaultConfig,
                    autoplayConfig: config?.autoplay,
                };
                subscriber.next(data);
            })));
    }
}
